import { useContext } from 'react';
import { PublicUserInfoContext } from '../contexts/PublicUserInfoContext';

export const useUserInfo = () => useContext(PublicUserInfoContext);
